"use client";

export type LegalTextSection = {
  title?: string;
  text?: string;
  label?: string;
  listIntro?: string;
  list?: string[];
  paragraphs?: string[];
};

type LegalDocumentPageProps = {
  title: string;
  subtitle: string;
  sections: LegalTextSection[];
  className?: string;
};

function LegalParagraph({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return (
    <p className={className}>
      {text.split("\n").map((line) => (
        <span key={line}>
          {line}
          <br />
        </span>
      ))}
    </p>
  );
}

function LegalSection({ section }: { section: LegalTextSection }) {
  return (
    <section className="space-y-3">
      {section.title && (
        <h2 className="app-document-title">
          {section.title}
        </h2>
      )}
      {section.label && <p className="font-medium">{section.label}</p>}
      {section.paragraphs?.map((paragraph) => (
        <LegalParagraph
          key={paragraph}
          text={paragraph}
          className="text-base text-foreground"
        />
      ))}
      {section.listIntro && (
        <div className="mt-2">
          {section.listIntro}
          {section.list && (
            <ul className="list-disc list-inside pl-4 mt-2">
              {section.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      )}
      {section.text?.split("\n\n").map((paragraph) => (
        <p className="mt-2" key={paragraph}>
          {paragraph}
        </p>
      ))}
    </section>
  );
}

export function LegalDocumentPage({
  title,
  subtitle,
  sections,
  className = "page-section",
}: LegalDocumentPageProps) {
  return (
    <section className={className}>
      <div className="max-w-4xl mx-auto mb-10">
        <div className="page-header">
          <h1 className="page-headline">
            {title}
          </h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>

        <section className="space-y-3">
          {sections.map((section, index) => (
            <LegalSection
              key={`${section.title ?? section.label}-${index}`}
              section={section}
            />
          ))}
        </section>
      </div>
    </section>
  );
}
